
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const FormLoadingState: React.FC = () => {
  return (
    <div className="space-y-6">
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-20 w-full" />
    </div>
  );
};

export default FormLoadingState;
